import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { VisitorTableRequest } from "./VisitorTableRequest";
import { VisitorOffenderUpdateRequest } from "./VisitorOffenderUpdateRequest";
import { VisitorParentChildAddRequest } from "./VisitorParentChildAddRequest";
import { VisitorParentChildRemoveRequest } from "./VisitorParentChildRemoveRequest";
import { VisitorLogRequest } from "./VisitorLogRequest";
import { VisitorAliasRequest } from "./VisitorAliasRequest";
import { VisitorAliasLookupRequest } from "./VisitorAliasLookupRequest";

@Injectable()
export class DataService_MultiStationViewVisitors {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	VisitorSelectorFilterInfoSelectList(SchoolID: number) {
		var postResult$ = new Subject();
		var url = "MultiStation/VisitorSelectorFilterInfoSelectList?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	VisitorTableSelectList(parms: VisitorTableRequest) {
		var postResult$ = new Subject();
		var url = "MultiStation/VisitorTableSelectList";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	VisitorExtendedInfoSelect(PersonID) {
		var postResult$ = new Subject();
		var url = "MultiStation/VisitorExtendedInfoSelect?PersonID=" + PersonID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	VisitorDemographicInfoSelect(PersonID) {
		var postResult$ = new Subject();
		var url = "MultiStation/VisitorDemographicInfoSelect?PersonID=" + PersonID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	VisitorHistorySelectList(PersonID) {
		var postResult$ = new Subject();
		var url = "MultiStation/VisitorHistorySelectList?PersonID=" + PersonID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	PassLoadExtendedInfo(VisitorPassID) {
		var postResult$ = new Subject();
		var url = "MultiStation/PassLoadExtendedInfo?VisitorPassID=" + VisitorPassID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	VisitorOffenderLookupHistorySelectList(PersonID) {
		var postResult$ = new Subject();
		var url = "MultiStation/VisitorOffenderLookupHistorySelectList?PersonID=" + PersonID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	VisitorOffenderLookupSelectList(PersonID) {
		var postResult$ = new Subject();
		var url = "MultiStation/VisitorOffenderLookupSelectList?PersonID=" + PersonID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	VisitorOffenderLookupSummarySelect(PersonID) {
		var postResult$ = new Subject();
		var url = "MultiStation/VisitorOffenderLookupSummarySelect?PersonID=" + PersonID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	VisitorOffenderUpdateEntry(parms: VisitorOffenderUpdateRequest) {
		var postResult$ = new Subject();
		var url = "MultiStation/VisitorOffenderUpdateEntry";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	VisitorParentChildSelectList(PersonID) {
		var postResult$ = new Subject();
		var url = "MultiStation/VisitorParentChildSelectList?PersonID=" + PersonID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	VisitorParentChildAdd(parms: VisitorParentChildAddRequest) {
		var postResult$ = new Subject();
		var url = "MultiStation/VisitorParentChildAdd";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	VisitorParentChildRemove(parms: VisitorParentChildRemoveRequest) {
		var postResult$ = new Subject();
		var url = "MultiStation/VisitorParentChildRemove";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	VisitorParentRelationshipSelectList() {
		var postResult$ = new Subject();
		var url = "MultiStation/VisitorParentRelationshipSelectList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	VisitorFacilitySelectList(SchoolID: number) {
		var postResult$ = new Subject();
		var url = "MultiStation/VisitorFacilitySelectList?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	VisitorLogSelectList(parms: VisitorLogRequest) {
		var postResult$ = new Subject();
		var url = "MultiStation/VisitorLogSelectList";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	VisitorLogDetailsSelect(VisitorPassDetailID) {
		var postResult$ = new Subject();
		var url = "MultiStation/VisitorLogDetailsSelect?VisitorPassDetailID=" + VisitorPassDetailID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	VisitorAliasSelectList(PersonID) {
		var postResult$ = new Subject();
		var url = "MultiStation/VisitorAliasSelectList?PersonID=" + PersonID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	VisitorAliasInsert(parms: VisitorAliasRequest) {
		var postResult$ = new Subject();
		var url = "MultiStation/VisitorAliasInsert";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	VisitorAliasDelete(parms: VisitorAliasRequest) {
		var postResult$ = new Subject();
		var url = "MultiStation/VisitorAliasDelete";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	VisitorAliasLookup(parms: VisitorAliasLookupRequest) {
		var postResult$ = new Subject();
		var url = "MultiStation/VisitorAliasLookup";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	VisitorTypeSelectList() {
		var postResult$ = new Subject();
		var url = "MultiStation/VisitorTypeSelectList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	VisitorStatusSelectList() {
		var postResult$ = new Subject();
		var url = "MultiStation/VisitorStatusSelectList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	PrintPass(VisitorPassID) {
		var postResult$ = new Subject();
		var url = "MultiStation/PrintPass?VisitorPassID=" + VisitorPassID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	CurrentSemesterStartDateSelect() {
		var postResult$ = new Subject();
		var url = "MultiStation/CurrentSemesterStartDateSelect?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}
}
